import type {
  GetComponentStyle,
} from '@vtaits/react-paginator';

export const pagesStyle: GetComponentStyle<unknown> = () => ({
  display: 'inline-block',
  verticalAlign: 'bottom',
});
